<template>
  <div class="print">
    <div class="print-item" v-for="(item, index) in printList" :key="item.id">
      <h2>{{ qrcodeHead[index] }}</h2>
      <img :src="qrcodeUrl[index]" />
      <!-- <div class="item-container">
        <div class="item-left">
          <p>产品名称：{{ item.productName }}</p>
          <p>溯源码：{{ item.traceCode }}</p>
          <p>批次码：{{ item.batchCode }}</p>
        </div>
      </div> -->
      <h3>{{ qrcodeFoot[index] }}</h3>
    </div>
    <el-button type="primary" v-show="show" :size="$store.state.buttonSize" @click="clickPrint">打印</el-button>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import { getProductInfo } from '@/api/qrcode'
export default {
  data() {
    return {
      show: true,
      qrcodeUrl: [],
      qrcodeHead: [],
      qrcodeFoot: [],
      urlString: [],
      printList: null
    }
  },
  methods: {
    clickPrint() {
      this.show = false
      window.setTimeout(function () {
        window.print()
      }, 100)
    }
  },
  mounted() {
    this.printList = JSON.parse(window.sessionStorage.getItem('printList'))
    this.printList.forEach((item, index) => {
      getProductInfo(item.barcode).then(res => {
        this.qrcodeHead.push(res.data.qrcodeHead)
        this.qrcodeFoot.push(res.data.qrcodeFoot)
      })
      // this.urlString[index] = `https://www.ydtncpzlzs.cn:9000/index.html#/traceInquiry?b=${item.batchCode}&p=${item.barcode}&t=${item.traceCode}`
      this.urlString[index] = `https://www.ydtncpzlzs.cn:9000/index.html#/c?t=${item.traceCode}`
      QRCode.toDataURL(
        this.urlString[index],
        { errorCorrectionLevel: 'H', version: 12 },
        (err, url) => {
          if (!err) {
            this.qrcodeUrl.push(url)
          }
        }
      )
    })
  }
}
</script>
<style lang="scss">
.print {
  width: 106mm;
  // border-right: solid 1px #000;
  overflow: hidden;
  .print-item {
    width: 50mm;
    height: 40mm;
    float: left;
    margin-bottom: 0;
    &:nth-child(odd) {
      margin-left: 1mm;
      margin-right: 3mm;
    }
    img{
      width: 24mm;
      height: 24mm;
      margin: 0 auto;
      margin-top: 1mm;
      display: block;
    }
    h2 {
      font-size: 1mm;
      text-align: center;
      padding-top: 1mm;
      font-weight: bold;
    }
    h3 {
      font-size: 0.7mm;
      text-align: center;
      font-weight: bold;
      padding-top: 1mm;
    }
    .item-container {
      padding-top: 1mm;
      padding-left: 1mm;
      .item-left {
        p {
          font-size: 0.4mm;
          line-height: 3mm;
          padding-bottom: 1mm;
        }
      }
    }
  }
}
</style>
